module.exports = __webpack_public_path__ + "static/media/trimex_victoria.3cb71dde.png";